import React from "react";

const RequiredLabel = ({ htmlFor, children }) => {
  return (
    <label className="tittle-text" htmlFor={htmlFor}>
      <span className="text-danger">* </span>
      {children}
    </label>
  );
};

export default RequiredLabel;
